var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 91,
    viewBox: "0 0 186 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#13647b}.cls-2,.cls-4{fill:none}.cls-3{fill:#4b4b4b}.cls-4{stroke:#4b4b4b;stroke-width:2px}.cls-5{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rent_icon_-_Chosen",
    transform: "translate(-1381 -823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    d: "M9739.6 397.767l6.177-3.82 3.576 3.82h9.265v5.689a1.436 1.436 0 0 1-1.463 1.869c-1.95.163-14.142.731-16.58-.406s-.975-7.152-.975-7.152z",
    className: "cls-1",
    transform: "translate(-8202.242 491)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    cx: 7.5,
    cy: 7,
    className: "cls-1",
    rx: 7.5,
    ry: 7,
    transform: "translate(1472.758 864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    d: "M9562.855 382.693h22.934s1.509 16.748-11.266 16.7-11.668-10.109-11.668-10.109z",
    className: "cls-1",
    transform: "translate(-8161.242 491)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rent",
    transform: "translate(768 394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_819",
    d: "M0 0H186V91H0z",
    className: "cls-2",
    transform: "translate(613 429)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    transform: "translate(-9178.242 -670)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mixer",
    transform: "translate(9794.242 1129.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    d: "M52.916 33.3a1.372 1.372 0 0 0-1.483-1.483h-1.245v-1.133a1.4 1.4 0 0 0-1.6-1.6H38.56V27.7h3.19a1.372 1.372 0 0 0 1.5-1.467v-1.211a3.8 3.8 0 0 0 .558-.191 1.34 1.34 0 0 0 .8-1.324v-4.036h1.372a1.324 1.324 0 0 0 1.356-1.276 12.523 12.523 0 0 0 0-1.6 1.34 1.34 0 0 0-1.324-1.276 5.967 5.967 0 0 0-.925 0c-.447 0-.638-.1-.782-.542A6.827 6.827 0 0 0 37.922 9.9h-22.06a6.843 6.843 0 0 0-3.669 12.617 6.588 6.588 0 0 0 3.525 1.069 1.34 1.34 0 0 1 1.436 1.707Q15.192 36.06 13.2 46.826a1.6 1.6 0 0 1-1.6 1.467A2.68 2.68 0 0 0 9 51.165a2.744 2.744 0 0 0 2.76 2.584h36.211a2.026 2.026 0 0 0 2.153-2.042 2.058 2.058 0 0 0-2.137-2.074H43.3v-2.248a.542.542 0 0 1 .335-.542 12.25 12.25 0 0 0 5.088-5.136.686.686 0 0 1 .463-.287h2.2a1.34 1.34 0 0 0 1.5-1.5q.062-3.32.03-6.62zm-8.183-16.525h1.324v1.26h-1.324zm-2.807 9.571h-8.167v-1.293h8.167zM25.56 36.634a12.091 12.091 0 0 0 6.269 10.113c.431.255.622.494.542.973v.75a3.862 3.862 0 0 1-.494-.207 13.5 13.5 0 0 1-7.72-12.155c-.08-2.775 0-5.551 0-8.326a2.7 2.7 0 0 1 2.775-2.791h5.439v1.276a1.356 1.356 0 0 0 1.436 1.4h3.333v1.388H27.059a1.356 1.356 0 0 0-1.6 1.42c.053 2.075-.027 4.133.101 6.159zM43.313 19.5v1.324s-5.152.112-10.4 0a76.563 76.563 0 0 1-10.591-.51 58.11 58.11 0 0 1 10.607-.877c5.248-.16 10.352-.128 10.432-.128v.191zm4.658 31.519c.351 0 .67 0 .8.415a.686.686 0 0 1-.7.941h-35.99a2.265 2.265 0 0 1-.734-.1 1.324 1.324 0 0 1-.893-1.467 1.372 1.372 0 0 1 1.276-1.18 2.839 2.839 0 0 0 2.855-2.568q1.6-8.693 3.19-17.355c.271-1.436.479-2.9.814-4.323a2.664 2.664 0 0 0-2.409-3.19 5.966 5.966 0 0 1-3.669-1.212 5.5 5.5 0 0 1-1.818-5.934 5.344 5.344 0 0 1 4.9-3.8h22.026a5.407 5.407 0 0 1 5.5 4.4h.112v2.377s-5.615 0-11.166.144c-3.19.128-5.838.3-7.72.526-2.9.351-4 .8-4.068 1.6a.75.75 0 0 0 .223.59c.319.351.941.989 12.011 1.085h2.791c4.115 0 7.609 0 7.975-.08v1.6H27.2a4.163 4.163 0 0 0-4.434 4.418v7.736a15.058 15.058 0 0 0 12.061 14.949 17.178 17.178 0 0 0 3.19.319c3.366.128 6.652.112 9.954.112zm-14.244-3.411a13.032 13.032 0 0 0 8.215 0v1.962a30.02 30.02 0 0 1-7.417-.351c-.766-.191-.766-.191-.766-.957zm13.367-5.79a10.942 10.942 0 0 1-20.035-4.068c-.223-1.467-.175-2.983-.255-4.514v-2.76H48.88V33.874a12.841 12.841 0 0 1-1.786 7.944zm4.418-1.787h-2.074a17.546 17.546 0 0 0 .75-6.811h1.324z",
    className: "cls-3",
    transform: "translate(-8.996 -9.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_projector",
    transform: "translate(9853.461 1132.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    d: "M12.283 48.555a3.473 3.473 0 0 1-3.473-3.473V18.833a3.433 3.433 0 0 1 3.433-3.433h25.482l-1.373 1.676A12.115 12.115 0 0 0 44.146 36.8a13.707 13.707 0 0 0 1.575 0 11.913 11.913 0 0 0 8.079-3.025 12.115 12.115 0 0 0 4.038-9.086 11.974 11.974 0 0 0-2.766-7.713l-1.456-1.556h8.763a3.412 3.412 0 0 1 3.412 3.392v26.25a3.473 3.473 0 0 1-3.473 3.473zm0-31.075a1.353 1.353 0 0 0-1.373 1.373V45.1a1.413 1.413 0 0 0 1.413 1.413h50.056a1.413 1.413 0 0 0 1.414-1.413V18.853a1.353 1.353 0 0 0-1.353-1.333h-4.6l.141.242a13.751 13.751 0 0 1 1.9 7.087 14.134 14.134 0 0 1-14.14 14.135 17.078 17.078 0 0 1-1.757 0 14.357 14.357 0 0 1-10.56-21.262l.141-.242z",
    className: "cls-3",
    transform: "translate(-8.81 -10.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_139",
    d: "M0 0H11.631V2.06H0z",
    className: "cls-3",
    transform: "translate(7.168 13.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_140",
    d: "M0 0H11.631V2.06H0z",
    className: "cls-3",
    transform: "translate(7.168 19.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_141",
    d: "M0 0H11.631V2.06H0z",
    className: "cls-3",
    transform: "translate(7.168 25.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_142",
    d: "M0 0H9.228V3.251H0z",
    className: "cls-3",
    transform: "translate(39.435 36.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143",
    d: "M0 0H9.228V3.251H0z",
    className: "cls-3",
    transform: "translate(8.359 36.972)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78",
    className: "cls-4",
    transform: "translate(22.781 .099)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79",
    className: "cls-4",
    transform: "translate(28.781 6.099)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80",
    className: "cls-4",
    transform: "translate(33.781 11.099)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    className: "cls-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon_drill",
    transform: "translate(9922.871 1131.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    d: "M24.05 54.962a2.773 2.773 0 0 1-2.773-2.773v-5.528l6.809-4.387h2.773v-9.388a1.439 1.439 0 0 0-1.439-1.439h-2.756v-4.195H17.89V13.74h23.8a6.879 6.879 0 0 1 6.932 6.6 6.774 6.774 0 0 1-6.756 7.019h-1.637v15.424l2.3 3.159v6.317a2.755 2.755 0 0 1-2.773 2.773zM22.611 47.4v4.791a1.439 1.439 0 0 0 1.439 1.439h15.67a1.4 1.4 0 0 0 1.421-1.264V47.24h-9.335l-3.352-3.668-5.808 3.828zm9.775-1.492H40.9l-2-2.773V25.9h2.86a5.51 5.51 0 0 0 5.54-5.263 5.422 5.422 0 0 0-5.423-5.58H19.171v1.6h3.51v1.316h-3.51v1.755h3.51v1.492h-3.51v1.755h3.51v1.316h-3.51v1.6h12.951v1.334H30.1v2.931h.123a2.773 2.773 0 0 1 1.9 2.72v10.661h-1.9l2.158 2.351zM28 30.113h.755v-2.86H28V30.1z",
    className: "cls-3",
    transform: "translate(2.326 -13.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    d: "M19.76 24.753a4.826 4.826 0 0 1-4.37-4.212v-.088H7.037a.667.667 0 0 1-.667-.667.667.667 0 0 1 .667-.667h8.178v-.158a4.808 4.808 0 0 1 4.422-4.212h5.036a.684.684 0 0 1 .667.684v8.774a.667.667 0 0 1-.667.667zm0-8.774a3.51 3.51 0 0 0-3.089 3.51v.456a3.51 3.51 0 0 0 3.089 3.51h.193V16zm2.194 7.441h1.316a.667.667 0 0 0 .667-.667V16.61a.667.667 0 0 0-.667-.667h-1.528a.667.667 0 0 0-.667.667v6.142a.667.667 0 0 0 .737.7z",
    className: "cls-3",
    transform: "translate(-6.37 -12.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_146",
    d: "M0 0H3.861V1.334H0z",
    className: "cls-3",
    transform: "translate(41.169 2.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_147",
    d: "M0 0H3.861V1.334H0z",
    className: "cls-3",
    transform: "translate(41.169 5.019)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentChosen);
export default __webpack_public_path__ + "static/media/rent-chosen.8a75fc73711b2668d0ee5f50407da8dd.svg";
export { ForwardRef as ReactComponent };